import React from 'react'
import createUsePollingWithCache from 'hooks/createUsePollingWithCache'
import { getData as apiGetData } from 'api/Api'

type LabelNamesData = {
  Labels: {
    Id: number
    Name: string
  }[]
}

const usePollingWithCache = createUsePollingWithCache<string | null>({
  getData: (ids, setData) => {
    apiGetData('LabelNames', { ids }).then((data: LabelNamesData) => {
      ids.forEach(id => setData(id, (data.Labels.find(Board => Board.Id === Number(id)) || { Name: null }).Name))  
    })
  }
})

type RenderData = {
  name: string | null | undefined
  error?: any
}

type Props = {
  children?: (data: RenderData) => React.ReactNode

  id: number
}

const LabelName: React.FC<Props> = ({
  children,

  id,
}) => {
  const name = usePollingWithCache(String(id))

  if (children) return children({
    name,
  })

  return name as any
}

export default LabelName
